import { useGetFile } from '@/hooks/useFiles';

interface UsePOEDataParams {
  riskKey: string | undefined;
  poeLocation: string;
  fallbackPOELocation: string | undefined;
  name: string;
}

interface UsePOEDataResult {
  file: unknown;
  fileStatus: 'pending' | 'success' | 'error';
  evidenceFileValue: string;
}

export function usePOEData({
  riskKey,
  poeLocation,
  fallbackPOELocation,
}: UsePOEDataParams): UsePOEDataResult {
  const { data: evidenceFile } = useGetFile(
    { name: `evidence/${riskKey}` },
    { enabled: !!riskKey }
  );

  const evidenceFileValue =
    typeof evidenceFile === 'string'
      ? evidenceFile
      : evidenceFile
        ? JSON.stringify(evidenceFile)
        : '';

  const { data: poeFile, status: poeFileStatus } = useGetFile(
    { name: `proofs/${poeLocation}` },
    { enabled: !!poeLocation }
  );

  const enableFallback =
    !!fallbackPOELocation &&
    poeFileStatus !== 'pending' &&
    (poeFileStatus === 'error' || (poeFileStatus === 'success' && !poeFile));

  const { data: fallbackFile, status: fallbackStatus } = useGetFile(
    { name: `proofs/${fallbackPOELocation}` },
    { enabled: enableFallback }
  );

  const file = enableFallback ? fallbackFile : poeFile;
  const fileStatus = enableFallback ? fallbackStatus : poeFileStatus;

  return { file, fileStatus, evidenceFileValue };
}
